import React, { Fragment } from "react";
import { IconElement } from "../../elements/icon.element";

export function Quote({
  credit,
  position,
  children,
  source = null,
  floated = null,
}) {
  return (
    <section
      className={`overflow-hidden ${
        floated
          ? floated.toLowerCase() === "right"
            ? "lg:float-right lg:-mr-1/3"
            : "lg:float-left lg:-ml-1/3"
          : "py-8"
      } ${floated ? "lg:max-w-lg lg:px-12" : ""}`}
    >
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative">
          <blockquote
            className={`${floated ? "mt-0" : "mt-10"}`}
            style={{
              paddingLeft: 0,
              border: "none",
              fontStyle: "normal",
              marginTop: floated ? 0 : "inherit",
            }}
          >
            <div className="max-w-3xl mx-auto text-left text-2xl font-sans leading-9 font-bold text-gray-900">
              <p
                className={`${
                  floated ? "py-6 px-8 bg-gray-200 text-gray-900" : ""
                }`}
              >
                {children}
              </p>
            </div>
            <footer>
              <div className="md:flex md:items-center md:justify-start">
                <div className="mt-3 text-left md:mt-0 md:flex md:items-center">
                  {credit && (
                    <div className="text-base font-normal text-gray-900 not-italic">
                      {credit}
                    </div>
                  )}

                  {position && (
                    <Fragment>
                      <svg
                        className="hidden md:block mx-1 h-5 w-5 text-pink-600"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M11 0h3L9 20H6l5-20z" />
                      </svg>

                      <div className="text-base font-normal text-gray-700 not-italic">
                        {position}
                      </div>
                    </Fragment>
                  )}

                  {source && (
                    <a
                      href={source}
                      target="_blank"
                      rel="noreferrer noopener"
                      className="block text-sm ml-4 text-gray-500"
                      aria-label="source"
                    >
                      <IconElement icon="externalLink" aria-hidden="true" />
                    </a>
                  )}
                </div>
              </div>
            </footer>
          </blockquote>
        </div>
      </div>
    </section>
  );
}
